import styled from "styled-components";

type ContainerProps = {
  $columns: number;
  $rows?: number;
  $activeIndex?: number;
}
export const Container = styled.div<ContainerProps>`
  display: grid;
  --gap: 8px;
  gap: var(--gap);
  --translateXCoef: var(--gap);
  --translateYCoef: var(--gap);
  border-radius: 12px;
  background-color: #fff;
  padding: 4px;
  margin: 0 15px;
  position: relative;
  margin-bottom: 20px;
  grid-template-columns: repeat(${props=>(props.$columns / (props.$rows || 1))}, 1fr);
  ${props => {
    let translateX = 0;
    let translateY = 0;
    const activeIndex = props.$activeIndex;
    const columns = props.$columns;

    if (!activeIndex||columns > activeIndex) {
      translateX = activeIndex || 0;
      return `
        --translateX: ${translateX};
        --translateY: ${translateY};
        --translateXCoef: ${translateX >= 1 ? `calc(var(--gap) * ${translateX})` : '0px'};
        --translateYCoef: 0px;
      `
    }
    
    if (activeIndex%columns === 0) {
      translateX = 0;
      translateY = Math.ceil(activeIndex/columns);
      return `
        --translateX: ${translateX};
        --translateY: ${translateY};
        --translateXCoef: 0px;
        --translateYCoef: calc(var(--gap) * ${translateY});
      `
    }
    
    translateX = activeIndex%columns;
    translateY = Math.ceil(activeIndex/columns)-1;
    return `
      --translateX: ${translateX};
      --translateY: ${translateY};
      --translateXCoef: ${translateX >= 1 ? `calc(var(--gap) * ${translateX})` : '0px'};
      --translateYCoef: ${translateY > 0 ? `calc(var(--gap) * ${translateY})` : '0px'};
    `
  }}

  &::before{
    content:'';
    position: absolute;
    top: 4px;
    height: 31.2px;
    left: 4px;
    width: calc((100% / ${props=>(props.$columns / (props.$rows || 1))}) - var(--gap));
    background-color: #577CF0;
    border-radius: 8px;
    translate: 
      calc((100% * var(--translateX)) + var(--translateXCoef)) 
      calc((100% * var(--translateY)) + var(--translateYCoef));
    transition: translate 0.3s ease 0s;
    pointer-events: none;
  }
`

type ItemProps = {
  $active?: boolean
}
export const Item = styled.div<ItemProps>`
  position: relative;
  z-index: 2;
  transition: color 0.3s ease 0s;
  line-height: 1.2;
  cursor: pointer;
  padding: 6px 8px;
  text-align: center;
  color:${props => props.$active ? '#fff' : '#000'};
`